import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';

const Home = () => {
  const { settings } = useSettings();
  const [companies, setCompanies] = useState([]);
  const [search, setSearch] = useState('');

  const appName = settings.app_name || 'Vocaverse';
  const heroTitle = (settings.home_hero_title && settings.home_hero_title !== 'Welcome to My Blog')
    ? settings.home_hero_title
    : `Welcome to ${appName}`;

  useEffect(() => {
    fetch('/api/public/blog')
      .then(async (r) => (r.ok ? r.json() : { blogs: [] }))
      .then((data) => setCompanies(data.blogs || []))
      .catch(() => setCompanies([]));
  }, []);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return companies;
    return companies.filter(
      (c) =>
        (c.name || '').toLowerCase().includes(q) ||
        (c.subdomain || '').toLowerCase().includes(q)
    );
  }, [companies, search]);

  return (
    <div className="min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">
            {heroTitle}
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {settings.home_hero_body || 'Find your workspace below.'}
          </p>
        </div>

        <div className="max-w-xl mx-auto mb-12">
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search workspaces..."
            className="w-full px-5 py-3 rounded-xl border border-gray-200 shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none text-lg"
          />
        </div>

        {filtered.length === 0 ? (
          <div className="text-center text-gray-500 py-12">
            {search.trim() ? 'No workspaces match your search.' : 'No workspaces available.'}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((company) => (
              <Link
                key={company.id}
                to={`/${company.subdomain}`}
                className="block p-6 bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md hover:border-indigo-200 transition-all"
              >
                <div className="flex items-center gap-4">
                  <img
                    src={settings.app_logo_url || '/logo.png'}
                    alt={company.name}
                    className="w-12 h-12 rounded-full object-cover border border-gray-200"
                    onError={(e) => {
                      e.currentTarget.src = '/logo.png';
                    }}
                  />
                  <div>
                    <h3 className="text-lg font-bold text-gray-900">{company.name}</h3>
                    <p className="text-sm text-gray-500">/{company.subdomain}</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;
